import { TEnumerationType } from './type';

export type TDataSource =
  | 'steamcharts'
  | 'mscience'
  | 'npd'
  | 'newzoo'
  | 'gsd'
  | 'hatchet'
  | 'gamalytic'
  | 'alinea'
  | 'vginsights'
  | 'famitsu'
  | 'steamData'
  | 'noUpdate'
  | 'ampere'
  | 'databrain'
  | 'mobileMetrics'
  | 'pcMetrics'
  | 'consoleMetrics'
  | 'gamesOwned'
  | string;
export type TDataSourceMetrics =
  | 'pcu'
  | 'acu'
  | 'steamFollowers'
  | 'steamReviews'
  | 'digitalRevenue'
  | 'units'
  | 'digitalARPPU'
  | 'ast'
  | 'physicalRevenue'
  | 'physicalUnits'
  | 'mau'
  | 'playerShare'
  | 'mauGrowth'
  | 'mauNew'
  | 'mauReturning'
  | 'lifetimePlayer'
  | 'timeSpent0h'
  | 'timeSpent1h'
  | 'timeSpent5h'
  | 'timeSpent10h'
  | 'timeSpent25h'
  | 'timeSpent50h'
  | 'avgDailyPlaytime'
  | 'avgDailySessions'
  | 'avgPlaytimePerSession'
  | 'avgMonthlyPlaytime'
  | 'avgMonthlySessions'
  | 'avgDaysPlayed'
  | 'stickness'
  | 'totalHours'
  | 'churn'
  | 'acquisition'
  | 'retentionD1'
  | 'retentionD2'
  | 'retentionD4'
  | 'retentionD7'
  | 'retentionD14'
  | 'retentionD28'
  | 'digitalUnitsGSD'
  | 'physicalUnitsGSD'
  | 'digitalRevenueGSD'
  | 'physicalRevenueGSD'
  | 'hoursWatched'
  | 'airtime'
  | 'peakCCV'
  | 'avgCCV'
  | 'premiumRevenue'
  | 'cumulativeRevenue'
  | 'unitVgi'
  | 'cumulativeUits'
  | 'price'
  | 'weightedPrice'
  | 'lifetimeWeightedPrice'
  | 'playersByCountry'
  | 'avgPlaytime'
  | 'totalFollowers'
  | 'famitsu_salesOfSelectedTime'
  | 'famitsu_revenueOfSelectedTime'
  | 'famitsu_cumulativeSales'
  | 'famitsu_cumulativeRevenueFamitsu'
  | 'famitsu_priceFamitsu'
  | 'ampere_mau'
  | 'ampere_previousMAU'
  | 'ampere_addedMAU'
  | 'ampere_newMAU'
  | 'ampere_retainedMAU'
  | 'ampere_churnedMAU'
  | 'ampere_dau'
  | 'ampere_newDAU'
  | 'ampere_avgMonthlyPlaytimeAmpere'
  | 'ampere_acquisitionRate'
  | 'ampere_stickness'
  | 'ampere_lifetimePlayers'
  | 'ampere_avgDaillyPlaytime'
  | 'ampere_d1'
  | 'ampere_d7'
  | 'ampere_d14'
  | 'ampere_d28'
  | 'ampere_d60'
  | 'ampere_rollingD1'
  | 'ampere_rollingD7'
  | 'ampere_rollingD14'
  | 'ampere_rollingD28'
  | 'ampere_rollingD60'
  | 'steamData_SteamPCU'
  | 'steamData_SteamACU'
  | 'steamData_SteamFollowers'
  | 'steamData_SteamReviews'
  | 'steamData_premiumRevenue'
  | 'steamData_cumulativeRevenue'
  | 'steamData_unit'
  | 'steamData_cumulativeUnits'
  | 'steamData_price'
  | 'steamData_lifetimeWeightedPrice'
  | 'steamData_playersByCountry'
  | 'steamData_avgPlaytime'
  | 'steamData_totalFollowers'
  | 'mobileRevenue_mobileMetrics'
  | 'mobileDownload_mobileMetrics'
  | 'pcDigitalRevenue_pcMetrics'
  | 'pcPhysicalRevenue_pcMetrics'
  | 'pcSteamPCU_pcMetrics'
  | 'pcMAU_pcMetrics'
  | 'consoleDigitalRevenue_consoleMetrics'
  | 'consolePhysicalRevenue_consoleMetrics'
  | 'consoleMAU_consoleMetrics'
  | 'famitsu_priceFamitsu_console'

  | 'databrain__total_revenue'
  | 'databrain__lifetime_total_revenue'
  | 'databrain__base_game_sales_units'
  | 'databrain__lifetime_base_game_sales_units'
  | 'source_steam__hourly_ccu'
  | 'mscienceLifetimeDigitalRevenue'
  | 'mscienceLifetimeDigitalUnits'
  | (string & {});

export interface IDataSourceMetricProp {
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  value: string;
  platform?: string;
  icon: string;
  // metric的source必须和dataSource的key保持一致，为了在转换为接口的souceMap中用，否则找不到
  source: TDataSource;
  // 接口使用的source，为空则使用source字段
  interfaceSource?: string;
  // 自身的key
  key: string;
  enumType: TEnumerationType;
}

export interface IDataSourceProp {
  // 自身的key
  key: string;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: string;
  // 图标对应的名称
  icon: string;
  // 展示在什么平台
  platform?: string;
  children?: IDataSourceMetricProp[];
  // 包含的数据源，因为前端的DATA_SOURCE更像一个分类，但映射到后端的source是会变化的，所以这个字段是记录子项中包含了哪些数据源
  // 多个数据源以逗号分隔，在填入初始化值的时候使用
  includes: string;
  // children是否为空，这个参数是动态加入的参数，为空在级联筛选器中会走特殊逻辑
  isEmpty?: boolean;
  enumType: TEnumerationType;
}

export type IDataSource = Record<TDataSource, IDataSourceProp>;
export type IDataSourceMetrics = Record<
  TDataSourceMetrics,
  IDataSourceMetricProp
>;

export const DATA_SOURCE: IDataSource = {
  steamcharts: {
    label: 'PCU',
    labelKey: 'dbi_no_translate_pcu',
    value: 'steamcharts',
    includes: 'steamcharts',
    platform: 'pc,console',
    icon: 'steam',
    key: 'steamcharts',
    enumType: 'dataSource',
  },
  mscience: {
    label: 'Mscience',
    labelKey: 'dbi_no_translate_mscience',
    value: 'mscience',
    includes: 'mscience',
    platform: 'pc,console,pc&console',
    icon: 'Mscience',
    key: 'mscience',
    enumType: 'dataSource',
  },
  npd: {
    label: 'NPD',
    labelKey: 'dbi_no_translate_npd',
    value: 'npd',
    includes: 'npd',
    platform: 'pc,console,pc&console',
    icon: 'npd',
    key: 'npd',
    enumType: 'dataSource',
  },
  newzoo: {
    label: 'User Engagement',
    labelKey: 'dbi_no_translate_user_engagement',
    value: 'newzoo',
    includes: 'newzoo',
    platform: 'pc,console',
    icon: 'newzoo',
    key: 'newzoo',
    enumType: 'dataSource',
  },
  gsd: {
    label: 'GSD',
    labelKey: 'dbi_no_translate_gsd',
    value: 'gsd',
    includes: 'gsd',
    platform: 'pc,console,pc&console',
    icon: 'gsd',
    key: 'gsd',
    enumType: 'dataSource',
  },
  hatchet: {
    label: 'Streaming',
    labelKey: 'dbi_no_translate_streaming',
    value: 'hatchet',
    includes: 'hatchet',
    platform: 'pc,console,pc&console',
    icon: 'hatchet',
    key: 'hatchet',
    enumType: 'dataSource',
  },
  gamalytic: {
    label: 'Steam Sales',
    labelKey: 'dbi_no_translate_steam_sales',
    value: 'gamalytic',
    includes: 'gamalytic',
    platform: 'pc',
    icon: 'gamalytic',
    key: 'gamalytic',
    enumType: 'dataSource',
  },
  alinea: {
    label: 'Alinea Analytics',
    labelKey: 'dbi_no_translate_alinea_analytics',
    value: 'alinea',
    includes: 'alinea',
    platform: 'pc&console',
    icon: 'alinea',
    key: 'alinea',
    enumType: 'dataSource',
  },
  vginsights: {
    label: 'Steam Sales',
    labelKey: 'dbi_no_translate_steam_sales',
    value: 'vginsights',
    includes: 'vginsights',
    platform: 'pc',
    // Steam Sales 业务上展示 Steam icon（数据源 key 仍为 vginsights）
    icon: 'steam',
    key: 'vginsights',
    enumType: 'dataSource',
  },
  vginsight: {
    label: 'VGInsights',
    labelKey: 'dbi_no_translate_steam_vginsights',
    value: 'vginsights',
    includes: 'vginsights',
    platform: 'pc',
    icon: 'vginsights',
    key: 'vginsights',
    enumType: 'dataSource',
  },
  famitsu: {
    label: 'Famitsu',
    labelKey: 'dbi_no_translate_famitsu',
    value: 'famitsu',
    includes: 'famitsu',
    platform: 'pc,console',
    icon: 'famitsu',
    key: 'famitsu',
    enumType: 'dataSource',
  },
  steamData: {
    label: 'Steam Data',
    labelKey: 'dbi_metric_steamdata',
    value: 'steamData',
    platform: 'pc&console',
    includes: 'vginsights,steamcharts',
    icon: 'steam',
    key: 'steamData',
    enumType: 'dataSource',
  },
  noUpdate: {
    label: 'No-Update',
    labelKey: 'dbi_metric_no_update',
    value: 'newzoo',
    platform: 'pc&console',
    includes: 'newzoo',
    icon: 'newzoo',
    key: 'noUpdate',
    enumType: 'dataSource',
  },
  ampere: {
    label: 'Other Vendor',
    labelKey: 'dbi_no_translate_ampere',
    value: 'ampere',
    includes: 'ampere',
    platform: 'pc&console',
    icon: 'ampere',
    key: 'ampere',
    enumType: 'dataSource',
  },
  mobileMetrics: {
    label: 'Mobile Metrics',
    labelKey: 'dbi_no_translate_mobile_metrics',
    value: 'mobileMetrics',
    includes: '',
    platform: 'companies',
    icon: '',
    key: 'mobileMetrics',
    enumType: 'dataSource',
  },
  pcMetrics: {
    label: 'PC Metrics',
    labelKey: 'dbi_no_translate_pc_metrics',
    value: 'pcMetrics',
    includes: '',
    platform: 'companies',
    icon: '',
    key: 'pcMetrics',
    enumType: 'dataSource',
  },
  consoleMetrics: {
    label: 'Console Metrics',
    labelKey: 'dbi_no_translate_console_metrics',
    value: 'consoleMetrics',
    includes: '',
    platform: 'companies',
    icon: '',
    key: 'consoleMetrics',
    enumType: 'dataSource',
  },
  gamesOwned: {
    label: 'Games Owned',
    labelKey: 'dbi_no_translate_game_owned',
    value: 'gameOwned',
    includes: '',
    platform: 'companies',
    icon: '',
    key: 'gamesOwned',
    enumType: 'dataSource',
  },
  databrain: {
    label: 'DataBrain',
    labelKey: '',
    value: 'databrain',
    includes: 'databrain',
    platform: 'pc,console,pc&console',
    icon: 'databrain',
    key: 'databrain',
    enumType: 'dataSource',
  },
  vginsightsPC: {
    label: 'VG Insights',
    labelKey: '',
    value: 'vginsights',
    includes: 'vginsights',
    platform: 'pc',
    icon: 'steam',
    key: 'vginsightsPC',
    enumType: 'dataSource',
  },
  revenue: {
    label: 'Revenue',
    labelKey: '',
    value: 'revenue',
    includes: 'mscience,npd,gsd',
    platform: 'pc&console',
    icon: '',
    key: 'revenue',
    enumType: 'dataSource',
  },
  japanSales: {
    label: 'Japan Sales',
    labelKey: 'dbi_japan_sales',
    value: 'japanSales',
    includes: 'famitsu',
    platform: 'pc&console',
    icon: '',
    key: 'japanSales',
    enumType: 'dataSource',
  },
  mau: {
    label: 'MAU',
    labelKey: 'dbi_metric_mau',
    value: 'mau',
    platform: 'pc&console',
    includes: 'newzoo',
    icon: '',
    key: 'mau',
    enumType: 'dataSource',
  },
  dau: {
    label: 'DAU',
    labelKey: 'dbi_metric_dau',
    value: 'dau',
    platform: 'pc&console',
    includes: 'newzoo',
    icon: '',
    key: 'dau',
    enumType: 'dataSource',
  },
  engagement: {
    label: 'Engagement',
    labelKey: 'dbi_metric_engagement',
    value: 'engagement',
    platform: 'pc&console',
    includes: 'newzoo',
    icon: '',
    key: 'engagement',
    enumType: 'dataSource',
  },
  retention: {
    label: 'Retention',
    labelKey: 'dbi_metric_retention',
    value: 'retention',
    platform: 'pc&console',
    includes: 'newzoo',
    icon: '',
    key: 'retention',
    enumType: 'dataSource',
  },
  options: {
    label: 'Opinions',
    labelKey: 'dbi_opinions',
    value: 'opinions',
    platform: 'pc&console',
    includes: 'options',
    icon: '',
    key: 'options',
    enumType: 'dataSource',
  },
  appannie_mobile: {
    label: 'data.ai',
    value: 'appannie',
    icon: 'appannie',
    platform: 'mobile',
    includes: 'appannie',
    key: 'appannie_mobile',
    enumType: 'dataSource',
  },
  databrain_mobile: {
    label: 'DataBrain',
    value: 'databrain',
    icon: 'databrain',
    platform: 'mobile',
    includes: 'databrain',
    key: 'databrain_mobile',
    enumType: 'dataSource',
  },
  ogdb_mobile: {
    label: 'DataBrain',
    value: 'ogdb',
    icon: 'databrain',
    platform: 'mobile',
    includes: 'databrain',
    key: 'databrain_mobile',
    enumType: 'dataSource',
  },
  sensortower_mobile: {
    label: 'Sensor Tower',
    value: 'sensortower',
    icon: 'sensorTower',
    platform: 'mobile',
    includes: 'sensortower',
    key: 'sensortower_mobile',
    enumType: 'dataSource',
  },
};

export const DATA_SOURCE_METRICS: IDataSourceMetrics = {
  pcu: {
    label: 'PCU',
    labelKey: 'dbi_metric_pcu',
    value: 'pcu',
    platform: 'pc,console',
    icon: 'steam',
    source: 'steamcharts',
    key: 'pcu',
    enumType: 'metric',
  },
  avgPlayers: {
    label: 'Avg. Players',
    labelKey: 'dbi_metric_avgplayers',
    value: 'acu',
    platform: 'pc',
    icon: 'steam',
    source: 'steamcharts',
    key: 'avgPlayers',
    enumType: 'metric',
  },
  acu: {
    label: 'ACU',
    labelKey: 'dbi_metric_acu',
    value: 'acu',
    platform: 'pc,console',
    icon: 'steam',
    source: 'steamcharts',
    key: 'acu',
    enumType: 'metric',
  },
  // 保留下载配置所需的历史元数据；PC&Console 活动选择器不再注册该指标。
  steamFollowers: {
    label: 'Steam Followers',
    labelKey: 'dbi_metric_steam_followers',
    value: 'steamfollowers',
    platform: 'pc,console,pc&console',
    icon: 'steam',
    source: 'steamcharts',
    key: 'steamFollowers',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamReviews: {
    label: 'Steam Reviews',
    labelKey: 'dbi_metric_steam_reviews',
    value: 'steamreviews',
    platform: 'pc,console,pc&console',
    icon: 'steam',
    source: 'steamcharts',
    key: 'steamReviews',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  digitalRevenue: {
    label: 'Digital Revenue($)',
    labelKey: 'dbi_metric_digitalRevenue',
    value: 'digitalRevenue',
    platform: 'pc,console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'digitalRevenue',
    enumType: 'metric',
  },
  digitalUnits: {
    label: 'Digital Units',
    labelKey: 'dbi_metric_digital_units',
    value: 'units',
    platform: 'pc&console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'digitalUnits',
    enumType: 'metric',
  },
  units: {
    label: 'Units',
    labelKey: 'dbi_metric_units',
    value: 'units',
    platform: 'pc,console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'units',
    enumType: 'metric',
  },
  digitalARPPUSimple: {
    label: 'Digital ARPPU($) ',
    labelKey: 'dbi_metric_digital_arpu_$',
    value: 'digitalARPPU',
    platform: 'pc',
    icon: 'Mscience',
    source: 'mscience',
    key: 'digitalARPPUSimple',
    enumType: 'metric',
  },
  digitalARPPU: {
    label: 'Digital ARPPU($) (US only)',
    labelKey: 'dbi_metric_digitalARPPU',
    value: 'digitalARPPU',
    platform: 'pc,console,pc&console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'digitalARPPU',
    enumType: 'metric',
  },
  ast: {
    label: 'AST($)',
    labelKey: 'dbi_metric_ast_$',
    value: 'ast',
    platform: 'pc,console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'ast',
    enumType: 'metric',
  },
  astSimple: {
    label: 'AST',
    labelKey: 'dbi_metric_ast',
    value: 'ast',
    platform: 'pc&console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'astSimple',
    enumType: 'metric',
  },
  physicalRevenue: {
    label: 'Physical Revenue($)',
    labelKey: 'dbi_metric_physical_revenue',
    value: 'revenue',
    platform: 'pc,console,pc&console',
    icon: 'npd',
    source: 'npd',
    key: 'physicalRevenue',
    enumType: 'metric',
  },
  physicalUnits: {
    label: 'Physical Units',
    labelKey: 'dbi_metric_physical_units',
    value: 'physical_units',
    platform: 'pc,console,pc&console',
    icon: 'npd',
    source: 'npd',
    key: 'physicalUnits',
    enumType: 'metric',
  },
  mau: {
    label: 'MAU',
    labelKey: 'dbi_mau',
    value: 'mau',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'mau',
    enumType: 'metric',
  },
  playerShare: {
    label: 'Player Share',
    labelKey: 'dbi_metric_player_share',
    value: 'player_share',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'playerShare',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  mauGrowth: {
    label: 'MAU Growth',
    labelKey: 'dbi_metric_mau_growth',
    value: 'mau_growth',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'mauGrowth',
    enumType: 'metric',
  },
  mauNew: {
    label: 'MAU - New',
    labelKey: 'dbi_metric_mau_new',
    value: 'mau_new',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'mauNew',
    enumType: 'metric',
  },
  mauReturning: {
    label: 'MAU - Returning',
    labelKey: 'dbi_metric_mau_returning',
    value: 'mau_returning',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'mauReturning',
    enumType: 'metric',
  },
  lifetimePlayer: {
    label: 'Lifetime Players',
    labelKey: 'dbi_metric_lifetime_player',
    value: 'lifetime_player',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'lifetimePlayer',
    enumType: 'metric',
  },
  timeSpent0h: {
    label: 'Time Spent 0-1 hrs',
    labelKey: 'dbi_metric_time_spent_0H',
    value: 'time_spent_0H',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'timeSpent0h',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  timeSpent1h: {
    label: 'Time Spent 1-5 hrs',
    labelKey: 'dbi_metric_time_spent_1H',
    value: 'time_spent_1H',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'timeSpent1h',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  timeSpent5h: {
    label: 'Time Spent 5-10 hrs',
    labelKey: 'dbi_metric_time_spent_5H',
    value: 'time_spent_5H',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'timeSpent5h',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  timeSpent10h: {
    label: 'Time Spent 10-25 hrs',
    labelKey: 'dbi_metric_time_spent_10H',
    value: 'time_spent_10H',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'timeSpent10h',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  timeSpent25h: {
    label: 'Time Spent 25-50 hrs',
    labelKey: 'dbi_metric_time_spent_25H',
    value: 'time_spent_25H',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'timeSpent25h',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  timeSpent50h: {
    label: 'Time Spent > 50 hrs',
    labelKey: 'dbi_metric_time_spent_50H',
    value: 'time_spent_50H',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'timeSpent50h',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  avgDailyPlaytime: {
    label: 'Avg Daily Playtime (mins)',
    labelKey: 'dbi_metric_avg_daily_playtime',
    value: 'avg_daily_playtime',
    platform: 'pc',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'avgDailyPlaytime',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  avgDailySessions: {
    label: 'Avg Daily Sessions',
    labelKey: 'dbi_metric_avg_daily_sessions',
    value: 'avg_daily_sessions',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'avgDailySessions',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  avgPlaytimePerSession: {
    label: 'Avg Playtime Per Session (mins)',
    labelKey: 'dbi_metric_avg_playtime_per_session',
    value: 'avg_playtime_per_session',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'avgPlaytimePerSession',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  avgMonthlyPlaytime: {
    label: 'Avg Monthly Playtime (hours)',
    labelKey: 'dbi_metric_avg_monthly_playtime',
    value: 'avg_monthly_playtime',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'avgMonthlyPlaytime',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  avgMonthlySessions: {
    label: 'Avg Monthly Sessions',
    labelKey: 'dbi_metric_avg_monthly_sessions',
    value: 'avg_monthly_sessions',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'avgMonthlySessions',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  avgDaysPlayed: {
    label: 'Avg Days Played',
    labelKey: 'dbi_metric_avg_days_played',
    value: 'avg_days_played',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'avgDaysPlayed',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  stickness: {
    label: 'Stickness',
    labelKey: 'dbi_metric_stickiness',
    value: 'stickiness',
    platform: 'pc',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'stickness',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  totalHours: {
    label: 'Total Hours',
    labelKey: 'dbi_metric_total_hours',
    value: 'total_hours',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'totalHours',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  churn: {
    label: 'Churn %',
    labelKey: 'dbi_metric_churn',
    value: 'churn',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'churn',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  acquisition: {
    label: 'Acquisition %',
    labelKey: 'dbi_metric_acquisition',
    value: 'acquisition',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'acquisition',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  retentionD1: {
    label: 'Retention D1',
    labelKey: 'dbi_retention_d1',
    value: 'retention_d1',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'retentionD1',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  retentionD2: {
    label: 'Retention D2',
    labelKey: 'dbi_retention_d2',
    value: 'retention_d2',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'retentionD2',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  retentionD4: {
    label: 'Retention D4',
    labelKey: 'dbi_retention_d4',
    value: 'retention_d4',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'retentionD4',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  retentionD7: {
    label: 'Retention D7',
    labelKey: 'dbi_retention_d7',
    value: 'retention_d7',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'retentionD7',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  retentionD14: {
    label: 'Retention D14',
    labelKey: 'dbi_retention_d14',
    value: 'retention_d14',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'retentionD14',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  retentionD28: {
    label: 'Retention D28',
    labelKey: 'dbi_retention_d28',
    value: 'retention_d28',
    platform: 'pc,console',
    icon: 'newzoo',
    source: 'newzoo',
    key: 'retentionD28',
    interfaceSource: 'newzoo_weight',
    enumType: 'metric',
  },
  digitalRevenueGSD: {
    label: 'Digital Revenue(€)',
    labelKey: 'dbi_metric_gsd_digital_revenue_euro',
    value: 'gsd_digitalRevenue',
    platform: 'pc,console,pc&console',
    icon: 'gsd',
    source: 'gsd',
    key: 'digitalRevenueGSD',
    enumType: 'metric',
  },
  digitalUnitsGSD: {
    label: 'Digital Units',
    labelKey: 'dbi_metric_gsd_digital_units',
    value: 'gsd_digitalUnits',
    platform: 'pc,console,pc&console',
    icon: 'gsd',
    source: 'gsd',
    key: 'digitalUnitsGSD',
    enumType: 'metric',
  },
  physicalRevenueGSD: {
    label: 'Physical Revenue(€)',
    labelKey: 'dbi_metric_gsd_physical_revenue_euro',
    value: 'gsd_physicalRevenue',
    platform: 'pc,console,pc&console',
    icon: 'gsd',
    source: 'gsd',
    key: 'physicalRevenueGSD',
    enumType: 'metric',
  },
  physicalUnitsGSD: {
    label: 'Physical Units',
    labelKey: 'dbi_metric_gsd_physical_units',
    value: 'gsd_physicalUnits',
    platform: 'pc,console,pc&console',
    icon: 'gsd',
    source: 'gsd',
    key: 'physicalUnitsGSD',
    enumType: 'metric',
  },
  hoursWatched: {
    label: 'Hours Watched',
    labelKey: 'dbi_metric_hourswatched_simple',
    value: 'hoursWatched',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'hoursWatched',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  hoursWatchedHour: {
    label: 'Hours Watched(hours)',
    labelKey: 'dbi_metric_hourswatched',
    value: 'hoursWatched',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'hoursWatchedHour',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  airtime: {
    label: 'Airtime(hours)',
    labelKey: 'dbi_metric_airtime',
    value: 'airtime',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'airtime',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  airtimeSimple: {
    label: 'Airtime',
    labelKey: 'dbi_metric_airtime_simple',
    value: 'airtime',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'airtimeSimple',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  peakCCV: {
    label: 'Peak CCV',
    labelKey: 'dbi_metric_peakccv',
    value: 'peakCCV',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'peakCCV',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  peakCCVWrong: {
    label: 'Peak CCV',
    labelKey: 'dbi_metric_peakccv',
    value: 'peackCCV',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'peakCCVWrong',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  avgCCV: {
    label: 'Avg CCV',
    labelKey: 'dbi_metric_avgccv',
    value: 'avgCCV',
    platform: 'pc,console',
    icon: 'hatchet',
    source: 'hatchet',
    key: 'avgCCV',
    interfaceSource: 'stream',
    enumType: 'metric',
  },
  premiumRevenue: {
    label: 'Premium Revenue($)',
    labelKey: 'dbi_metric_est_revenue',
    value: 'est_revenue',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'premiumRevenue',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamCumulativeRevenue: {
    label: 'Steam Cumulative Revenue',
    labelKey: 'dbi_metric_cumulative_revenue',
    value: 'est_cumulative_revenue',
    platform: 'pc&console',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'steamCumulativeRevenue',
    enumType: 'metric',
  },
  cumulativeRevenue: {
    label: 'Cumulative Revenue',
    labelKey: 'dbi_metric_cumulative_revenue',
    value: 'est_cumulative_revenue',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'cumulativeRevenue',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  unitVgi: {
    label: 'Units',
    labelKey: 'dbi_metric_units',
    value: 'est_units',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'unitVgi',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  cumulativeUits: {
    label: 'Cumulative Units',
    labelKey: 'dbi_metric_est_cumulative_units',
    value: 'est_cumulative_units',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'cumulativeUits',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamCumulativeUits: {
    label: 'Steam Cumulative Units',
    labelKey: 'dbi_metric_est_cumulative_units',
    value: 'est_cumulative_units',
    platform: 'pc&console',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'steamCumulativeUits',
    enumType: 'metric',
  },
  price: {
    label: 'Price($)',
    labelKey: 'dbi_metric_price_dol',
    value: 'est_price',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'price',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  weightedPrice: {
    label: 'Weighted Price($)',
    labelKey: 'dbi_metric_weighted_price',
    value: 'weighted_price',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'weightedPrice',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  lifetimeWeightedPrice: {
    label: 'Lifetime weighted price($)',
    labelKey: 'dbi_metric_lifetime_weighted_price',
    value: 'lifetime_weighted_price',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'lifetimeWeightedPrice',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  playersByCountry: {
    label: 'Players by country',
    labelKey: 'dbi_metric_players_by_country',
    value: 'players_by_country',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'playersByCountry',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  avgPlaytime: {
    label: 'Avg. Playtime(mins)',
    labelKey: 'dbi_metric_playtime',
    value: 'playtime',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'avgPlaytime',
    enumType: 'metric',
  },
  totalFollowers: {
    label: 'Total Followers',
    labelKey: 'dbi_metric_followers',
    value: 'followers',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'totalFollowers',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  famitsu_salesOfSelectedTime: {
    label: 'Sales of selected time',
    labelKey: 'dbi_metric_jpseg_sales',
    value: 'week_sales',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_salesOfSelectedTime',
    enumType: 'metric',
  },
  famitsu_salesOfSelectedTime_pcconsole: {
    label: 'Sales of selected time',
    labelKey: 'dbi_metric_jpseg_sales',
    value: 'famitsu_sales',
    platform: 'pc&console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_salesOfSelectedTime_pcconsole',
    enumType: 'metric',
  },
  famitsu_salesOfSelectedTime$: {
    label: 'Sales of selected time($)',
    labelKey: 'dbi_top_sales_of_selected_time$',
    value: 'sales',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_salesOfSelectedTime$',
    enumType: 'metric',
  },
  famitsu_revenueOfSelectedTime: {
    label: 'Revenue of selected time',
    labelKey: 'dbi_metric_jpseg_revenue',
    value: 'revenue',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_revenueOfSelectedTime',
    enumType: 'metric',
  },
  famitsu_revenueOfSelectedTime$: {
    label: 'Revenue of selected time($)',
    labelKey: 'dbi_top_revenue_of_selected_time$',
    value: 'revenue',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_revenueOfSelectedTime$',
    enumType: 'metric',
  },
  famitsu_revenueOfSelectedTime_pcconsole: {
    label: 'Revenue of selected time($)',
    labelKey: 'dbi_top_revenue_of_selected_time$',
    value: 'famitsu_revenue',
    platform: 'pc&console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_revenueOfSelectedTime_pcconsole$',
    enumType: 'metric',
  },
  famitsu_cumulativeSales: {
    label: 'Cumulative Sales',
    labelKey: 'dbi_metric_jpseg_cumulative_sales',
    value: 'total_sales',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_cumulativeSales',
    enumType: 'metric',
  },
  famitsu_cumulativeRevenueFamitsu: {
    label: 'Cumulative Revenue',
    labelKey: 'dbi_metric_jpseg_cumulative_revenue',
    value: 'total_revenue',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_cumulativeRevenueFamitsu',
    enumType: 'metric',
  },
  famitsu_price_pcconsole: {
    label: 'Price($)',
    labelKey: 'dbi_metric_jptb_price',
    value: 'famitsu_price',
    platform: 'pc&console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_price_pcconsole',
    enumType: 'metric',
  },
  famitsu_priceFamitsu_console: {
    label: 'Price',
    labelKey: 'dbi_metric_jpseg_price',
    value: 'price',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_priceFamitsu_console',
    enumType: 'metric',
  },
  famitsu_priceFamitsu: {
    label: 'Price',
    labelKey: 'dbi_metric_jpseg_price',
    value: 'usd_price',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_priceFamitsu',
    enumType: 'metric',
  },
  famitsu_cumulativeSalesOfTheLatestWeek: {
    label: 'Cumulative Sales of the latest week',
    labelKey: 'dbi_top_cumulative_sales_of_the_latest_week',
    value: 'cumulative_sales',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_cumulativeSalesOfTheLatestWeek',
    enumType: 'metric',
  },
  famitsu_cumulativeSalesOfTheLatestWeek_pcconsole: {
    label: 'Cumulative Sales of the latest week',
    labelKey: 'dbi_top_cumulative_sales_of_the_latest_week',
    value: 'famitsu_cumulative_sales',
    platform: 'pc&console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_cumulativeSalesOfTheLatestWeek_pcconsole',
    enumType: 'metric',
  },
  famitsu_cumulativeRevenueOfTheLatestWeek: {
    label: 'Cumulative Revenue of the latest week',
    labelKey: 'dbi_top_cumulative_revenue_of_the_latest_week',
    value: 'cumulative_revenue',
    platform: 'console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_cumulativeRevenueOfTheLatestWeek',
    enumType: 'metric',
  },
  famitsu_cumulativeRevenueOfTheLatestWeek_pcconsole: {
    label: 'Cumulative Revenue of the latest week',
    labelKey: 'dbi_top_cumulative_revenue_of_the_latest_week',
    value: 'famitsu_cumulative_revenue',
    platform: 'pc&console',
    icon: 'famitsu',
    source: 'famitsu',
    key: 'famitsu_cumulativeRevenueOfTheLatestWeek_pcconsole',
    enumType: 'metric',
  },
  ampere_mau: {
    label: 'MAU',
    labelKey: 'dbi_metric_mau',
    value: 'ampere_mau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_mau',
    enumType: 'metric',
  },
  ampere_previousMAU: {
    label: 'Previous MAU',
    labelKey: 'dbi_metric_previous_mau',
    value: 'ampere_previous_mau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_previousMAU',
    enumType: 'metric',
  },
  ampere_addedMAU: {
    label: 'Added MAU',
    labelKey: 'dbi_metric_added_mau',
    value: 'ampere_added_mau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_addedMAU',
    enumType: 'metric',
  },
  ampere_newMAU: {
    label: 'New MAU',
    labelKey: 'dbi_metric_new_mau',
    value: 'ampere_new_mau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_newMAU',
    enumType: 'metric',
  },
  ampere_retainedMAU: {
    label: 'Retained MAU',
    labelKey: 'dbi_metric_retained_mau',
    value: 'ampere_retained_mau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_retainedMAU',
    enumType: 'metric',
  },
  ampere_churnedMAU: {
    label: 'Churned MAU',
    labelKey: 'dbi_metric_churned_mau',
    value: 'ampere_churned_mau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_churnedMAU',
    enumType: 'metric',
  },
  ampere_dau: {
    label: 'DAU',
    labelKey: 'dbi_metric_dau',
    value: 'ampere_dau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_dau',
    enumType: 'metric',
  },
  ampere_newUsers: {
    label: 'New Users',
    labelKey: '',
    value: 'ampere_new_dau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_newDAU',
    enumType: 'metric',
  },
  ampere_newDAU: {
    label: 'New DAU',
    labelKey: 'dbi_metric_new_dau',
    value: 'ampere_new_dau',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_newDAU',
    enumType: 'metric',
  },
  ampere_avgMonthlyPlaytimeAmpere: {
    label: 'Avg Monthly Playtime (hours)',
    labelKey: 'dbi_metric_avg_monthly_playtime',
    value: 'ampere_avg_monthly_playtime',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_avgMonthlyPlaytimeAmpere',
    enumType: 'metric',
  },
  ampere_acquisitionRate: {
    label: 'Acquisition Rate',
    labelKey: 'dbi_metric_acquisition_rate',
    value: 'ampere_acquisition_rate',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_acquisitionRate',
    enumType: 'metric',
  },
  ampere_stickness: {
    label: 'Stickness',
    labelKey: 'dbi_metric_stickiness',
    // TODO 这里可能有传参问题，待验证
    value: 'ampere_stickiness',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_stickness',
    enumType: 'metric',
  },
  ampere_lifetimePlayers: {
    label: 'Lifetime Players',
    labelKey: 'dbi_metric_lifetime_player',
    value: 'ampere_lifetime_users',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_lifetimePlayers',
    enumType: 'metric',
  },
  ampere_avgDaillyPlaytime: {
    label: 'Avg Daily Playtime (hours)',
    labelKey: 'dbi_metric_avg_dailly_playtime_hour',
    value: 'ampere_avg_dailly_playtime',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_avgDaillyPlaytime',
    enumType: 'metric',
  },
  ampere_d1: {
    label: 'D1',
    labelKey: 'dbi_metric_ampere_d1',
    value: 'ampere_d1',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_d1',
    enumType: 'metric',
  },
  ampere_d7: {
    label: 'D7',
    labelKey: 'dbi_metric_ampere_d7',
    value: 'ampere_d7',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_d7',
    enumType: 'metric',
  },
  ampere_d14: {
    label: 'D14',
    labelKey: 'dbi_metric_ampere_d14',
    value: 'ampere_d14',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_d14',
    enumType: 'metric',
  },
  ampere_d28: {
    label: 'D28',
    labelKey: 'dbi_metric_ampere_d28',
    value: 'ampere_d28',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_d28',
    enumType: 'metric',
  },
  ampere_d60: {
    label: 'D60',
    labelKey: 'dbi_metric_ampere_d60',
    value: 'ampere_d60',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_d60',
    enumType: 'metric',
  },
  ampere_rollingD1: {
    label: 'Rolling D1',
    labelKey: 'dbi_metric_rolling_d1',
    value: 'ampere_rolling_d1',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_rollingD1',
    enumType: 'metric',
  },
  ampere_rollingD7: {
    label: 'Rolling D7',
    labelKey: 'dbi_metric_rolling_d7',
    value: 'ampere_rolling_d7',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_rollingD7',
    enumType: 'metric',
  },
  ampere_rollingD14: {
    label: 'Rolling D14',
    labelKey: 'dbi_metric_rolling_d14',
    value: 'ampere_rolling_d14',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_rollingD14',
    enumType: 'metric',
  },
  ampere_rollingD28: {
    label: 'Rolling D28',
    labelKey: 'dbi_metric_rolling_d28',
    value: 'ampere_rolling_d28',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_rollingD28',
    enumType: 'metric',
  },
  ampere_rollingD60: {
    label: 'Rolling D60',
    labelKey: 'dbi_metric_rolling_d60',
    value: 'ampere_rolling_d60',
    platform: 'pc&console',
    icon: 'ampere',
    source: 'ampere',
    key: 'ampere_rollingD60',
    enumType: 'metric',
  },
  steamData_SteamPCU: {
    label: 'Steam PCU',
    labelKey: 'dbi_metric_steam_pcu',
    value: 'pcu',
    platform: 'pc&console',
    icon: 'steam',
    source: 'steamData',
    key: 'steamData_SteamPCU',
    interfaceSource: 'steamcharts',
    enumType: 'metric',
  },
  SteamPCU: {
    label: 'Steam PCU',
    labelKey: 'dbi_metric_steam_pcu',
    value: 'pcu',
    platform: 'pc&console',
    icon: 'steam',
    source: 'steamData',
    key: 'SteamPCU',
    interfaceSource: 'steamcharts',
    enumType: 'metric',
  },
  steamData_SteamACU: {
    label: 'Steam ACU',
    labelKey: 'dbi_metric_steam_acu',
    value: 'acu',
    platform: 'pc&console',
    icon: 'steam',
    source: 'steamData',
    key: 'steamData_SteamACU',
    interfaceSource: 'steamcharts',
    enumType: 'metric',
  },
  SteamACU: {
    label: 'Steam ACU',
    labelKey: 'dbi_metric_steam_acu',
    value: 'acu',
    platform: 'pc&console',
    icon: 'steam',
    source: 'steamData',
    key: 'SteamACU',
    interfaceSource: 'steamcharts',
    enumType: 'metric',
  },
  // 保留下载配置所需的历史元数据；PC&Console 活动选择器不再注册该指标。
  steamData_SteamFollowers: {
    label: 'Steam Followers',
    labelKey: 'dbi_metric_steam_followers',
    value: 'steamfollowers',
    platform: 'pc&console',
    icon: 'steam',
    source: 'steamData',
    key: 'steamData_SteamFollowers',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_SteamReviews: {
    label: 'Steam Reviews',
    labelKey: 'dbi_metric_steam_reviews',
    value: 'steamreviews',
    platform: 'pc',
    icon: 'steam',
    source: 'steamData',
    key: 'steamData_SteamReviews',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_premiumRevenue: {
    label: 'Premium Revenue($)',
    labelKey: 'dbi_metric_est_revenue',
    value: 'est_revenue',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_premiumRevenue',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_cumulativeRevenue: {
    label: 'Cumulative Revenue',
    labelKey: 'dbi_metric_jpseg_cumulative_revenue',
    value: 'est_cumulative_revenue',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_cumulativeRevenue',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_unit: {
    label: 'Units',
    labelKey: 'dbi_metric_units',
    value: 'est_units',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_unit',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_cumulativeUnits: {
    label: 'Cumulative Units',
    labelKey: 'dbi_metric_est_cumulative_units',
    value: 'est_cumulative_units',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_cumulativeUnits',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_price: {
    label: 'Price($)',
    labelKey: 'dbi_metric_price_dol',
    value: 'est_price',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_price',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_lifetimeWeightedPrice: {
    label: 'Lifetime weighted price($)',
    labelKey: 'dbi_metric_lifetime_weighted_price',
    value: 'lifetime_weighted_price',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_lifetimeWeightedPrice',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_playersByCountry: {
    label: 'Players by country',
    labelKey: 'dbi_metric_players_by_country',
    value: 'players_by_country',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_playersByCountry',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_avgPlaytime: {
    label: 'Avg. Playtime(mins)',
    labelKey: 'dbi_metric_playtime',
    value: 'playtime',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_avgPlaytime',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  steamData_totalFollowers: {
    label: 'Total Followers',
    labelKey: 'dbi_metric_followers',
    value: 'followers',
    platform: 'pc',
    icon: 'vginsights',
    source: 'steamData',
    key: 'steamData_totalFollowers',
    interfaceSource: 'vginsights',
    enumType: 'metric',
  },
  mobileRevenue_mobileMetrics: {
    label: 'Mobile Revenue',
    labelKey: '',
    value: 'mobile_revenue',
    platform: 'companies',
    icon: 'appannie',
    source: 'mobileMetrics',
    key: 'mobileRevenue_mobileMetrics',
    enumType: 'metric',
  },
  mobileDownload_mobileMetrics: {
    label: 'Mobile Download',
    labelKey: '',
    value: 'mobile_download',
    platform: 'companies',
    icon: 'appannie',
    source: 'mobileMetrics',
    key: 'mobileDownload_mobileMetrics',
    enumType: 'metric',
  },
  pcDigitalRevenue_pcMetrics: {
    label: 'PC Digital Revenue',
    labelKey: '',
    value: 'pc_digitalRevenue',
    platform: 'companies',
    icon: 'mscience',
    source: 'pcMetrics',
    key: 'pcDigitalRevenue_pcMetrics',
    enumType: 'metric',
  },
  pcDigitalRevenue_pcMetrics_split: {
    label: 'PC Digital Revenue',
    labelKey: '',
    value: 'pc_digital_revenue',
    platform: 'companies',
    icon: 'mscience',
    source: 'pcMetrics',
    key: 'pcDigitalRevenue_pcMetrics',
    enumType: 'metric',
  },
  pcPhysicalRevenue_pcMetrics: {
    label: 'PC Physical Revenue',
    labelKey: '',
    value: 'pc_physicalRevenue',
    platform: 'companies',
    icon: 'npd',
    source: 'pcMetrics',
    key: 'pcPhysicalRevenue_pcMetrics',
    enumType: 'metric',
  },
  pcPhysicalRevenue_pcMetrics_split: {
    label: 'PC Physical Revenue',
    labelKey: '',
    value: 'pc_physical_revenue',
    platform: 'companies',
    icon: 'npd',
    source: 'pcMetrics',
    key: 'pcPhysicalRevenue_pcMetrics',
    enumType: 'metric',
  },
  pcSteamPCU_pcMetrics: {
    label: 'PC Steam PCU',
    labelKey: '',
    value: 'pc_pcu',
    platform: 'companies',
    icon: 'steam',
    source: 'pcMetrics',
    key: 'pcSteamPCU_pcMetrics',
    enumType: 'metric',
  },
  pcMAU_pcMetrics: {
    label: 'PC MAU',
    labelKey: '',
    value: 'pc_mau',
    platform: 'companies',
    icon: 'newzoo',
    source: 'pcMetrics',
    key: 'pcMAU_pcMetrics',
    enumType: 'metric',
  },
  consoleDigitalRevenue_consoleMetrics: {
    label: 'Console Digital Revenue',
    labelKey: '',
    value: 'console_digitalRevenue',
    platform: 'companies',
    icon: 'mscience',
    source: 'consoleMetrics',
    key: 'consoleDigitalRevenue_consoleMetrics',
    enumType: 'metric',
  },
  consoleDigitalRevenue_consoleMetrics_split: {
    label: 'Console Digital Revenue',
    labelKey: '',
    value: 'console_digital_revenue',
    platform: 'companies',
    icon: 'mscience',
    source: 'consoleMetrics',
    key: 'consoleDigitalRevenue_consoleMetrics',
    enumType: 'metric',
  },
  consolePhysicalRevenue_consoleMetrics: {
    label: 'Console Physical Revenue',
    labelKey: '',
    value: 'console_physicalRevenue',
    platform: 'companies',
    icon: 'npd',
    source: 'consoleMetrics',
    key: 'consolePhysicalRevenue_consoleMetrics',
    enumType: 'metric',
  },
  consolePhysicalRevenue_consoleMetrics_split: {
    label: 'Console Physical Revenue',
    labelKey: '',
    value: 'console_physical_revenue',
    platform: 'companies',
    icon: 'npd',
    source: 'consoleMetrics',
    key: 'consolePhysicalRevenue_consoleMetrics',
    enumType: 'metric',
  },
  consoleMAU_consoleMetrics: {
    label: 'Console MAU',
    labelKey: '',
    value: 'console_mau',
    platform: 'companies',
    icon: 'newzoo',
    source: 'consoleMetrics',
    key: 'consoleMAU_consoleMetrics',
    enumType: 'metric',
  },
  steamRevenue_pcMetrics: {
    label: 'Steam Revenue',
    labelKey: 'dbi_metric_steam_revenue',
    value: 'est_revenue',
    platform: 'pc,pc&console',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'steamRevenue_pcMetrics',
    enumType: 'metric',
  },
  steamUnits_pcMetrics: {
    label: 'Steam Units',
    labelKey: 'dbi_metric_steam_units',
    value: 'est_units',
    platform: 'pc,pc&console',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'steamUnits_pcMetrics',
    enumType: 'metric',
  },
  steamPrice_pcMetrics: {
    label: 'Steam Price($)',
    labelKey: 'dbi_metric_steam_price$',
    value: 'est_price',
    platform: 'pc,pc&console',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'steamPrice_pcMetrics',
    enumType: 'metric',
  },
  estRevenue_pcMetrics: {
    label: 'Est.Revenue',
    labelKey: 'dbi_label_metric_est_revenue',
    value: 'est_revenue',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'estRevenue_pcMetrics',
    enumType: 'metric',
  },
  estUnit_pcMetrics: {
    label: 'Est.Units',
    labelKey: 'dbi_label_metric_est_units',
    value: 'est_units',
    platform: 'pc',
    icon: 'vginsights',
    source: 'vginsights',
    key: 'estUnit_pcMetrics',
    enumType: 'metric',
  },
  activeUsers_appannie: {
    label: 'Active Users',
    labelKey: 'dbi_active_users',
    value: 'dau',
    platform: 'mobile',
    icon: 'appannie',
    source: 'appannie',
    key: 'activeUsers_appannie',
    enumType: 'metric',
  },
  activeUsers_sensorTower: {
    label: 'Active Users',
    labelKey: 'dbi_active_users',
    value: 'dau',
    platform: 'mobile',
    icon: 'sensortower',
    source: 'sensortower',
    key: 'activeUsers_sensorTower',
    enumType: 'metric',
  },
  revenue_appannie: {
    label: 'Revenue',
    labelKey: 'dbi_revenue',
    value: 'revenue',
    platform: 'mobile',
    icon: 'appannie',
    source: 'appannie',
    key: 'revenue_appannie',
    enumType: 'metric',
  },
  revenue_sensorTower: {
    label: 'Revenue',
    labelKey: 'dbi_revenue',
    value: 'revenue',
    platform: 'mobile',
    icon: 'sensortower',
    source: 'sensortower',
    key: 'revenue_sensorTower',
    enumType: 'metric',
  },
  downloads_appannie: {
    label: 'Downloads',
    labelKey: 'dbi_downloads',
    value: 'download',
    platform: 'mobile',
    icon: 'appannie',
    source: 'appannie',
    key: 'downloads_appannie',
    enumType: 'metric',
  },
  downloads_sensorTower: {
    label: 'Downloads',
    labelKey: 'dbi_downloads',
    value: 'download',
    platform: 'mobile',
    icon: 'sensortower',
    source: 'sensortower',
    key: 'downloads_sensorTower',
    enumType: 'metric',
  },
  mentions_options: {
    label: 'Mentions',
    labelKey: 'dbi_mentions',
    value: 'Mentions',
    platform: 'pc&console',
    icon: '',
    source: 'options',
    key: 'mentions_options',
    enumType: 'metric',
  },
  brandHealth_options: {
    label: 'Brand Health',
    labelKey: '',
    value: 'Brand Health',
    platform: 'pc&console',
    icon: '',
    source: 'options',
    key: 'brandHealth_options',
    enumType: 'metric',
  },
  steamAllReviews_options: {
    label: 'Steam All reviews',
    labelKey: '',
    value: 'Steam All reviews',
    platform: 'pc&console',
    icon: '',
    source: 'options',
    key: 'steamAllReviews_options',
    enumType: 'metric',
  },
  steamAllReviewsPositive_options: {
    label: 'Steam All reviews Positive%',
    labelKey: '',
    value: 'Steam All reviews Positive%',
    platform: 'pc&console',
    icon: '',
    source: 'options',
    key: 'steamAllReviewsPositive_options',
    enumType: 'metric',
  },
  steamAddedReviews_options: {
    label: 'Steam Added Reviews',
    labelKey: '',
    value: 'Steam Added Reviews',
    platform: 'pc&console',
    icon: '',
    source: 'options',
    key: 'steamAddedReviews_options',
    enumType: 'metric',
  },
  steamAddedPositive_options: {
    label: 'Steam Added Positive%',
    labelKey: '',
    value: 'Steam Added Positive%',
    platform: 'pc&console',
    icon: '',
    source: 'options',
    key: 'steamAddedReviews_options',
    enumType: 'metric',
  },
  au_mobile: {
    label: 'Active Users',
    labelKey: 'dbi_active_users',
    value: 'au',
    platform: 'mobileDetailStats',
    icon: '',
    source: '',
    key: 'au_mobile',
    enumType: 'metric',
  },
  rv_mobile: {
    label: 'Revenue',
    labelKey: 'dbi_revenue',
    value: 'rv',
    platform: 'mobileDetailStats',
    icon: '',
    source: '',
    key: 'rv_mobile',
    enumType: 'metric',
  },
  dl_mobile: {
    label: 'Downloads',
    labelKey: 'dbi_downloads',
    value: 'dl',
    icon: '',
    source: '',
    key: 'dl_mobile',
    enumType: 'metric',
  },
  arpu_mobile: {
    label: 'ARPU',
    labelKey: 'dbi_arpu',
    value: 'arpu',
    icon: '',
    source: '',
    key: 'arpu_mobile',
    enumType: 'metric',
  },
  mr_mobile: {
    label: 'Monthly Retention',
    labelKey: 'dbi_monthly_retention',
    value: 'mr',
    icon: '',
    source: '',
    key: 'mr_mobile',
    enumType: 'metric',
  },
  lr_mobile: {
    label: 'Lifetime Retention',
    labelKey: 'dbi_lifetime_retention',
    value: 'lr',
    icon: '',
    source: '',
    key: 'lr_mobile',
    enumType: 'metric',
  },
  rp_mobile: {
    label: 'RPD',
    labelKey: 'dbi_rpd',
    value: 'rp',
    icon: '',
    source: '',
    key: 'rp_mobile',
    enumType: 'metric',
  },
  cr_mobile: {
    label: 'Cumulative Revenue',
    labelKey: 'dbi_metric_cumulative_revenue',
    value: 'cr',
    icon: '',
    source: '',
    key: 'cr_mobile',
    enumType: 'metric',
  },
  cd_mobile: {
    label: 'Cumulative Downloads',
    labelKey: 'dbi_metric_cumulative_downloads',
    value: 'cd',
    icon: '',
    source: '',
    key: 'cd_mobile',
    enumType: 'metric',
  },
  hw_mobile: {
    label: 'Hours Watched',
    labelKey: 'dbi_metric_hourswatched_simple',
    value: 'hw',
    icon: '',
    source: '',
    key: 'hw_mobile',
    enumType: 'metric',
  },
  at_mobile: {
    label: 'Airtime',
    labelKey: 'dbi_metric_airtime_simple',
    value: 'at',
    icon: '',
    source: '',
    key: 'hw_mobile',
    enumType: 'metric',
  },
  pk_mobile: {
    label: 'Peak CCV',
    labelKey: 'dbi_metric_peakccv',
    value: 'pk',
    icon: '',
    source: '',
    key: 'pk_mobile',
    enumType: 'metric',
  },
  ac_mobile: {
    label: 'Avg CCV',
    labelKey: 'dbi_metric_avgccv',
    value: 'ac',
    icon: '',
    source: '',
    key: 'pk_mobile',
    enumType: 'metric',
  },
  rpd_mobile: {
    label: 'RPD($)',
    labelKey: '',
    value: 'rpd',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'rpd_mobile',
    enumType: 'metric',
  },
  cumulativeRevenue_mobile: {
    label: 'Cumulative Revenue($)',
    labelKey: 'dbi_metric_cumulative_revenue_$',
    value: 'revenue',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'cumulativeRevenue_mobile',
    enumType: 'metric',
  },
  cumulativeDownloads_mobile: {
    label: 'Cumulative Downloads',
    labelKey: 'dbi_metric_cumulative_downloads',
    value: 'download',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'cumulativeRevenue_mobile',
    enumType: 'metric',
  },
  d2_mobile: {
    label: 'D2',
    value: 'D2',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'd2_mobile',
    enumType: 'metric',
  },
  d3_mobile: {
    label: 'D3',
    value: 'D3',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'd3_mobile',
    enumType: 'metric',
  },
  d7_mobile: {
    label: 'D7',
    value: 'D7',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'd7_mobile',
    enumType: 'metric',
  },
  d15_mobile: {
    label: 'D15',
    value: 'D15',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'd15_mobile',
    enumType: 'metric',
  },
  d31_mobile: {
    label: 'D31',
    value: 'D31',
    platform: 'mobile',
    icon: '',
    source: '',
    key: 'd31_mobile',
    enumType: 'metric',
  },
  // --- DataBrain KPI Trends (PC & Console) --- (prefixed only)
  databrain__total_revenue: {
    label: 'Total Revenue($)',
    labelKey: 'dbi_metric_total_revenue',
    value: 'databrain__total_revenue',
    platform: 'pc,console,pc&console',
    icon: 'databrain',
    source: 'databrain',
    key: 'databrain__total_revenue',
    enumType: 'metric',
  },
  databrain__lifetime_total_revenue: {
    label: 'Lifetime Total Revenue($)',
    labelKey: 'dbi_metric_lifetime_total_revenue',
    value: 'databrain__lifetime_total_revenue',
    platform: 'pc,console,pc&console',
    icon: 'databrain',
    source: 'databrain',
    key: 'databrain__lifetime_total_revenue',
    enumType: 'metric',
  },
  databrain__base_game_sales_units: {
    label: 'Base Game Sales Units',
    labelKey: 'dbi_metric_base_game_sales_units',
    value: 'databrain__base_game_sales_units',
    platform: 'pc,console,pc&console',
    icon: 'databrain',
    source: 'databrain',
    key: 'databrain__base_game_sales_units',
    enumType: 'metric',
  },
  databrain__lifetime_base_game_sales_units: {
    label: 'Lifetime Base Game Sales Units',
    labelKey: 'dbi_metric_lifetime_base_game_sales_units',
    value: 'databrain__lifetime_base_game_sales_units',
    platform: 'pc,console,pc&console',
    icon: 'databrain',
    source: 'databrain',
    key: 'databrain__lifetime_base_game_sales_units',
    enumType: 'metric',
  },
  source_steam__hourly_ccu: {
    label: 'Steam Hourly CCU',
    labelKey: 'dbi_top_kpiOverview_steam_hourly_ccu',
    value: 'source_steam__hourly_ccu',
    platform: 'pc,console,pc&console',
    icon: 'steam',
    source: 'source_steam',
    interfaceSource: 'source_steam',
    key: 'source_steam__hourly_ccu',
    enumType: 'metric',
  },
  // --- MScience KPI Trends (PC & Console) ---
  digitalRevenue_lifetime: {
    label: 'MScience Lifetime Digital Revenue($)',
    labelKey: 'dbi_metric_mscience_lifetime_digital_revenue',
    value: 'digitalRevenue_lifetime',
    platform: 'pc,console,pc&console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'digitalRevenue_lifetime',
    enumType: 'metric',
  },
  mscienceLifetimeDigitalRevenue: {
    label: 'MScience Lifetime Digital Revenue($)',
    labelKey: 'dbi_metric_mscience_lifetime_digital_revenue',
    value: 'mscienceLifetimeDigitalRevenue',
    platform: 'pc,console,pc&console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'mscienceLifetimeDigitalRevenue',
    enumType: 'metric',
  },
  mscienceLifetimeDigitalUnits: {
    label: 'MScience Lifetime Digital Units',
    labelKey: 'dbi_metric_mscience_lifetime_digital_units',
    value: 'mscienceLifetimeDigitalUnits',
    platform: 'pc,console,pc&console',
    icon: 'Mscience',
    source: 'mscience',
    key: 'mscienceLifetimeDigitalUnits',
    enumType: 'metric',
  },
};

export const convertDataSourceAndSource = (
  config: Record<TDataSource, string[]>,
  additionalFields: Record<string, Record<string, any>> = {},
) => {
  const result = Object.keys(config).map(
    (key: TDataSource): IDataSourceProp => {
      const child = config[key];
      const dataSourceConfig = DATA_SOURCE[key] || {};
      return {
        ...dataSourceConfig,
        isEmpty: !child?.length,
        children: child.map((metric) => DATA_SOURCE_METRICS[metric]) || [],
      };
    },
  );
  // console.log(result);
  // console.log(additionalFields);
  if (additionalFields) {
    Object.keys(additionalFields).forEach((key) => {
      result.forEach((parentItem: any) => {
        const targetValue = additionalFields[key]?.[parentItem.key] || '';
        if (key === 'isDefault') {
          // 如果配置项中的值是all，则选中子项，该逻辑在useFormContent中
          if (targetValue === 'all') {
            Object.assign(parentItem, {
              isDefault: true,
            });
            // 如果不是all，则是数组，表明子项中哪一项为选中状态
          } else {
            parentItem?.children?.forEach((childItem: any) => {
              Object.assign(childItem, {
                isDefault: targetValue.includes(childItem.value),
              });
            });
          }
        } else {
          Object.assign(parentItem, {
            [key]: targetValue || '',
          });
        }
      });
    });
  }
  return result;
};
